const devLog = {
  log: (...args: unknown[]) => {
    if (import.meta.env.DEV) console.log(...args)
  },
  warn: (...args: unknown[]) => {
    if (import.meta.env.DEV) console.warn(...args)
  }
}

const errorLog = {
  error: (...args: unknown[]) => console.error(...args)
}

export { devLog, errorLog }
